import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Paper,
  } from "@mui/material";
  import React, { useEffect } from "react";
import Chart from '../charts/chart';

  
  function WidgetPreview(props: any) {
    console.log(props)
    const [openPreviewDialog, setOpenPreviewDialog] = React.useState(false);
    const handlePreviewClose = () => {
      setOpenPreviewDialog(false);
      props.onclose();
    };
    const [print, setPrint] =React. useState(false);
    const [printObj, setPrintObj] = React.useState({print: false, viewType: 'Pie Chart'});
    function handleAfterPrint(data:any){
		setPrint(data)
		let obj={print: data, viewType: printObj.viewType}
		setPrintObj(obj)
		console.log(data)
	   }
    useEffect(()=> {
        if(props.open !== openPreviewDialog){
            setOpenPreviewDialog(props.open);
        }
    }, [props.open])
    return (
      <>
        <Dialog
          open={openPreviewDialog}
          keepMounted
          onClose={handlePreviewClose}
          maxWidth="xl"
        >
          <DialogTitle>{"Widget Preview"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
                <Paper style={{ width: 700, height: 270, margin: 3 }} elevation={3}>
					<Chart viewType={props.data.viewType} widgetData={{...props.data.WidgetData, queryObj:props.data.WidgetData?.queryObj}}  timeOut={1000} print={props.printObj} parentCallbackPrint={handleAfterPrint}/>
				</Paper>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button variant="outlined" onClick={handlePreviewClose}>
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
  
  export default WidgetPreview;
  